import get from 'lodash/get';
import { batch } from 'react-redux';

import { EXPIRE_TOKEN, SAVE_DOCUMENT_TITLE, SET_LOGIN_METHOD } from './constants';
import { WARNING_SOURCES } from '../../constants/WarningsConstants';
import { closeSSOPopup } from '../../utils/ssoPopupUtil';
import { addError } from '../ErrorActions';
import { clearWarnings } from '../WarningActions';

const IGNORED_ERROR_NUMBER_ON_EXPIRED_TOKEN = '114801';

export function expireToken(errorMessage, errorNumber) {
  return (dispatch, getState) => {
    const { auth } = getState();

    if (auth.isTokenExpired) {
      return;
    }

    const sessionExpirationErrorCode = get(
      auth,
      'sessionExpirationErrorCode',
      localStorage.getItem('sessionExpirationErrorCode')
    );

    if (errorNumber === sessionExpirationErrorCode) {
      const actorCodeWithDomain = get(
        auth,
        'actorCodeWithDomain',
        localStorage.getItem('actorCodeWithDomain')
      );

      localStorage.setItem('prevActorCodeWithDomain', actorCodeWithDomain);
    }

    localStorage.removeItem('token');
    localStorage.removeItem('loginMethod');
    localStorage.removeItem('isArchiveMode');
    localStorage.removeItem('isArchiveUser');

    closeSSOPopup();

    batch(() => {
      if (errorNumber !== '50001') {
        dispatch({
          type: SET_LOGIN_METHOD,
          loginMethod: null,
        });
        dispatch({
          type: SAVE_DOCUMENT_TITLE,
          title: document.title,
        });
        dispatch({
          type: EXPIRE_TOKEN,
        });
      }

      if (auth.isArchiveMode && auth.isArchiveUser) {
        dispatch(clearWarnings(WARNING_SOURCES.ARCHIVE_MODE));
      }

      errorNumber !== IGNORED_ERROR_NUMBER_ON_EXPIRED_TOKEN &&
        dispatch(addError({ message: errorMessage, code: errorNumber }));
    });
  };
}
